"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderAgent = void 0;
var ProviderAgent;
(function (ProviderAgent) {
    ProviderAgent["Ledger"] = "ledger";
    ProviderAgent["KeplrExtension"] = "keplr-extension";
    ProviderAgent["Mnemonic"] = "mnemonic";
    ProviderAgent["MetamaskExtension"] = "metamask-extension";
})(ProviderAgent = exports.ProviderAgent || (exports.ProviderAgent = {}));
